import React, {useRef, useState} from "react";
import {css} from "@emotion/css";
import {dropFromList} from "./ArrayHelper";
import {Alert, AlertTitle} from "@mui/material";
import SelectionTable from "../SelectionTable/SelectionTable";
import PropTypes from "prop-types";
import {RaikoCustomActionChip} from "../raikoCustomChip/raikoCustomActionChip/RaikoCustomActionChip";

const RaikoMultiSelectTable = (
    {
        isSingleSelect = false,
        tableHeader,
        tableData,
        pageCount,
        selectedItems,
        setSelectedItems,
        handleChangePagination,
        tableLoadingState = false,
        selectedItemsTitle = "موارد انتخاب شده",
        tableHintTitle = "موارد مورد نظر را انتخاب نمایید",
        notSelectedAnyItemAlertTitle = "هنوز هیچ موردی انتخاب نشده است !!",
        notSelectedAnyItemAlertDescription = [
            <span>
      لطفا <strong>آیتم</strong> مورد نظر خود را از جدول زیر انتخاب نمائید.
    </span>,
            <span>
      در نظر داشته باشید که حداقل یک <strong> آیتم </strong>را باید انتخاب
      نمائید.
    </span>,
        ],
    }) => {
    const popperRef = useRef(null);
    const positionRef = useRef({
        x: 0,
        y: 0,
    });
    const areaRef = useRef(null);
    const handleMouseMove = (event) => {
        positionRef.current = {x: event.clientX, y: event.clientY};

        if (popperRef.current != null) {
            popperRef.current.update();
        }
    };

    function handleDeleteItem(id) {
        let newSelected = [];

        selectedItems.map((item, index) => {
            if (item.id === id) {
                newSelected = dropFromList(selectedItems, index);
            }
        });

        setSelectedItems(newSelected);
    }

    return (
        <section
            className={css`
              display: flex;
              flex-direction: column;
            `}
        >
            {selectedItems.length > 0 ? (
                <section
                    className={css`
                      
                    `}
                >
          <span
              className={css`
                font-size: var(--text-size-medium);
                width: 100%;
                flex-shrink: 0;
                color: var(--color-text);
              `}
          >
            {selectedItemsTitle}
          </span>

                    <div
                        className={css`
                          display: flex;
                          flex-wrap: wrap;
                          flex-grow: 1 !important;
                          width: 100% !important;
                          margin-top: 1rem;
                          gap: 8px;
                        `}
                    >
                        {selectedItems.map((item, index) => {
                            return (
                                <RaikoCustomActionChip
                                    title={item.name}
                                    id={item.id}
                                    onClick={handleDeleteItem}
                                />
                            );
                        })}
                    </div>
                </section>
            ) : (
                <section
                    className={css`
                    `}
                >
                    <Alert severity="warning">
                        <AlertTitle>{notSelectedAnyItemAlertTitle}</AlertTitle>
                        <div
                            className={css`
                              display: flex;
                              flex-direction: column;
                              gap: 8px;
                              margin-top: 16px;
                            `}
                        >
                            {notSelectedAnyItemAlertDescription.map((item) => (
                                <div>
                                    {item}
                                </div>
                            ))}
                        </div>
                    </Alert>
                </section>
            )}

            <div
                className={css`
                  width: 100%;
                  margin-top: 16px;
                  overflow-x: scroll !important;
                `}
            >
        <span
            className={css`
              font-size: var(--text-size-medium);
              width: 100%;
              flex-shrink: 0;
              color: var(--color-text);
            `}
        >
          {tableHintTitle}
        </span>
                <div
                    className={css`
                      margin-top: 16px;
                    `}
                >
                    <SelectionTable
                        isSingleSelect={isSingleSelect}
                        data={tableData}
                        header={tableHeader}
                        isLoading={tableLoadingState}
                        selected={selectedItems}
                        setSelected={setSelectedItems}
                        pageCount={pageCount}
                        handlePaginationChange={handleChangePagination}
                    />
                </div>
            </div>
        </section>
    );
};

export default RaikoMultiSelectTable;

RaikoMultiSelectTable.propTypes = {
    tableHeader: PropTypes.array.isRequired,
    tableData: PropTypes.array.isRequired,
    pageCount: PropTypes.number.isRequired,
    selectedItems: PropTypes.array.isRequired,
    setSelectedItems: PropTypes.func.isRequired,
    handleChangePagination: PropTypes.func.isRequired,
    tableLoadingState: PropTypes.bool,
    selectedItemsTitle: PropTypes.string,
    tableHintTitle: PropTypes.string,
    notSelectedAnyItemAlertTitle: PropTypes.string,
    notSelectedAnyItemAlertDescription: PropTypes.array,
};
